/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });

window.$ = window.jQuery = require("jquery");

require("./partials/slimsy.js");
import { intersectionObservation } from "./partials/intersectionObservation.js";

/*************************************************/
/* Partials                                      */
/*************************************************/

import { header } from "./partials/header.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { imagesLinks } from "./partials/imagesLinks.js";
import {accordion} from "./partials/accordion.js";
import {slider} from "./partials/slider.js";
import {filter} from "./partials/filter.js";
import { collapsedText } from "./partials/collapsedText.js";
import { language } from "./partials/language.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {

    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });

    const body = document.querySelector("body"),
    bodyLoadingClass = "is-loading";
    
    intersectionObservation();
    header(body);
    menu();
    filter();
    imagesLinks();
    search();
    searchbar(body);
    accordion();
    slider();
    modal(body, bodyLoadingClass);
    video();
    cookies();
    collapsedText();
    language();
});
